<template>
  <div class="container">
    <div class="py-2 py-md-4 d-flex flex-column">
      <div class="mb-3">
        <p class="h2 mb-0">{{ menu.title }}</p>
        <p class="text-muted text-sm mb-0">{{ menu.description }}</p>
      </div>
      <FormInput
        @input="setKeyword"
        :value="keyword"
        :placeholder="t.keyword_placeholder"
        type="text"
        name="keywords"
        class="mb-0"
      />
    </div>
    <div class="row">
      <div class="d-flex d-md-none w-100 sticky-wrapper mb-3">
        <ExpandButton
          id="categoryFilter"
          :should-toggle="false"
          v-open-modal="'categoryChooser'"
          :title="t.category"
          block
        />
      </div>
      <Modal :title="t.category_title" identifier="categoryChooser" is-full-mobile>
        <div class="text-left">
          <LunchMenuFilters :t="t" @selectCategory="selectCategory" />
        </div>
      </Modal>
      <div class="col-md-6 col-lg-4 d-none d-md-block">
        <div class="sidebar-wrapper">
          <LunchMenuFilters :t="t" @selectCategory="selectCategory" />
        </div>
      </div>
      <div class="col-md-18 col-lg-20">
        <div v-if="visibleItems.length">
          <LunchMenuCategoryListing
            v-bind="category"
            :key="`category-${category.title}`"
            :slug="`category-${index}`"
            :ref="`category-${index}`"
            v-for="(category, index) in visibleItems"
          />
        </div>
        <div v-else>
          {{ t.results_empty }}
        </div>
      </div>
      <div class="mt-7">
        <LunchMenuPrivacy v-if="menu.privacy" :title="t.privacy" :privacyText="menu.privacy" />
        <Modal :title="t.allergens" identifier="lunchMenuAllergens">
          <Markdown class="text-left">{{ menu.allergy_definition }}</Markdown>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import FormInput from "./FormInput.vue";
import ExpandButton from "./ExpandButton";
import LunchMenuCategoryListing from "./LunchMenuCategoryListing";
import LunchMenuPrivacy from "./LunchMenuPrivacy";
import Modal from "./Modal";
import Markdown from "./Markdown";
import LunchMenuFilters from "./LunchMenuFilters";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LunchMenuList",
  components: {
    ExpandButton,
    LunchMenuCategoryListing,
    LunchMenuPrivacy,
    Modal,
    Markdown,
    LunchMenuFilters,
    FormInput,
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      visibleItems: "lunchMenu/getVisibleItems",
      keyword: "lunchMenu/getKeyword",
    }),
  },
  mounted() {
    this.setMenu(this.menu);
  },
  methods: {
    ...mapActions({
      setMenu: "lunchMenu/setMenu",
      setKeyword: "lunchMenu/setKeyword",
    }),
    selectCategory(idx) {
      let el = this.$refs[`category-${idx}`][0].$el;
      el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.sidebar-wrapper {
  position: sticky;
  top: $spacer-2;
}

.sticky-wrapper {
  background: $white;
  position: sticky;
  top: $spacer-2;
  left: $spacer-2;
  right: $spacer-2;
  z-index: $zi-high;
}
</style>
